import { useEffect, useState } from "react";
import { useLanguage } from "../i18n/LanguageContext";
import { legalContent, interpolate } from "../data/legalContent";
import api from "../lib/api";

export default function LegalPage({ contentKey, testId }) {
  const { t, lang } = useLanguage();
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api.get("/settings/public").then(({ data }) => setSettings(data)).catch(() => {});
  }, []);

  const content = legalContent[contentKey][lang];
  const vars = {
    business_name: settings?.business_name || "EliteTheBarber",
    legal_name: settings?.legal_name || "[WETTELIJKE BEDRIJFSNAAM]",
    kvk_number: settings?.kvk_number || "[KVK-NUMMER]",
    address: settings ? `${settings.address}, ${settings.postal_code} ${settings.city}` : "Vlampijpstraat 75g, 3534 AR Utrecht",
    phone: settings?.phone || "06 18885582",
    email: settings?.email || "[ZAKELIJK E-MAILADRES]",
    privacy_email: settings?.privacy_email || "[PRIVACY E-MAILADRES]",
    retention_months: settings?.data_retention_months ?? 24,
  };

  return (
    <div data-testid={testId} className="py-20 sm:py-28 px-4 sm:px-6 min-h-[60vh]">
      <div className="max-w-3xl mx-auto">
        <h1 className="font-serif text-3xl sm:text-4xl text-white mb-3 tracking-tight">{content.title}</h1>
        <p className="text-white/40 text-xs mb-10">{t("legal.lastUpdated")}: 2026</p>
        <p className="text-white/70 leading-relaxed mb-10">{interpolate(content.intro, vars)}</p>
        <div className="space-y-8">
          {content.sections.map((s) => (
            <div key={s.heading}>
              <h2 className="text-white text-lg font-medium mb-2">{s.heading}</h2>
              <p className="text-white/60 text-sm leading-relaxed">{interpolate(s.body, vars)}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
